import { useMutation } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { CREATE_BANKING_INSTANT_FUNDING_DEBIT_CARD } from '#client/mutations';

const useCreateInstantFundingDebitCard = () => {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const [mutation, { data, loading, error, errors }] = useMutation(
    CREATE_BANKING_INSTANT_FUNDING_DEBIT_CARD,
    {
      noThrow: true
    }
  );

  useLogError(errors, error);

  const createCard = async (instantFundingCardId) => {
    const response = await mutation({
      variables: {
        input: {
          businessEntityUuid,
          instantFundingCardId
        }
      }
    });

    return response;
  };

  return {
    data,
    createCard,
    loading,
    error
  };
};

export default useCreateInstantFundingDebitCard;
